import CheckboxFull from './CheckboxFull';
export default CheckboxFull;
